export default __webpack_public_path__ + "static/css-features-8e116c9526d048f2d07b8456daaf75ca.png";